import { createContext, useContext } from 'react';

// Registry a slot singolo: solo una pagina è montata per rotta, quindi basta
// tenere il "refresh handler" della pagina corrente. Il componente PullToRefresh
// fornisce il registry; le pagine registrano il proprio refetch via useRefreshHandler.
export const PullToRefreshContext = createContext(null);

export const usePullToRefreshRegistry = () => useContext(PullToRefreshContext);
